import React from 'react';

const getActionTone = (action) => {
  const type = String(action?.type || '').toUpperCase();
  const priority = String(action?.priority || '').toLowerCase();

  if (type.includes('RESTART') || priority === 'high' || priority === 'urgent') {
    return 'danger';
  }
  if (type.includes('OPEN_MONITORING') || type.includes('ASSIGN_TECHNICIAN')) {
    return 'primary';
  }
  return 'secondary';
};

const toneClass = {
  primary:
    'border-cyan-300/45 bg-cyan-500/20 text-cyan-100 shadow-[0_0_20px_-10px_rgba(34,211,238,0.95)] hover:bg-cyan-500/30',
  danger:
    'border-rose-300/50 bg-rose-500/20 text-rose-100 shadow-[0_0_20px_-10px_rgba(244,63,94,0.95)] hover:bg-rose-500/30',
  secondary:
    'border-slate-400/45 bg-transparent text-slate-100 hover:bg-slate-700/35',
};

export default function AIInsightPanel({ actions = [], onExecute, busy = false }) {
  if (!Array.isArray(actions) || actions.length === 0) {
    return (
      <div className="rounded-lg border border-cyan-300/25 bg-cyan-500/5 p-3">
        <p className="text-xs font-semibold text-cyan-100">AI Actions</p>
        <p className="mt-1 text-xs text-slate-300">Belum ada aksi otomatis saat ini.</p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-cyan-300/30 bg-cyan-500/5 p-3">
      <p className="text-xs font-semibold text-cyan-100 mb-2">AI Actions</p>
      <div className="ai-actions flex flex-wrap gap-2">
        {actions.map((action, i) => {
          const tone = getActionTone(action);
          return (
            <button
              key={`${action?.type || 'action'}-${i}`}
              className={`btn-action rounded-md border px-3 py-1.5 text-xs font-semibold transition-all duration-200 hover:-translate-y-0.5 ${toneClass[tone]}`}
              onClick={() => onExecute?.(action)}
              disabled={busy}
              type="button"
            >
              {action?.label || action?.type || 'Action'}
            </button>
          );
        })}
      </div>
    </div>
  );
}

